import { render, staticRenderFns } from "./HeaderHolder.vue?vue&type=template&id=093b3a1a&"
import script from "./HeaderHolder.vue?vue&type=script&lang=js&"
export * from "./HeaderHolder.vue?vue&type=script&lang=js&"
import style0 from "./HeaderHolder.vue?vue&type=style&index=0&id=093b3a1a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports